<div class="container mat-typography">
  <div class="mat-elevation-z2-surveycont">
    <div class="survey-select layout-row">
      <mat-label class="name-label">{{ 'labels.inputs.Survey Name' | translate }}</mat-label>
      <mat-select (selectionChange)="onSurveyChange($event)">
        @for (surveyData of allSurveyData; track surveyData) {
          <mat-option [value]="surveyData">
            {{ surveyData.name }}
          </mat-option>
        }
      </mat-select>
    </div>

    <hr />

    <div>
      @for (component of componentGroups; track component) {
        @if (component[0].componentKey) {
          <h2>component[0].componentKey</h2>
        }
        <div class="layout-column display-questions">
          @for (question of component; track question) {
            <div class="layout-row question">
              <mat-label class="flex-40 question-text">{{ question.text }}</mat-label>
              <mat-radio-group class="flex-60 radio-group-spacing" [(ngModel)]="question.answer">
                @for (options of question.responseDatas; track options) {
                  <mat-radio-button class="layout-column radio-button" [value]="options">
                    <span class="wrap-mat-radio-label">
                      {{ options.text }}
                    </span>
                  </mat-radio-button>
                }
              </mat-radio-group>
            </div>
            @if (question.answer) {
              <div>{{ 'labels.text.Your answer is' | translate }}: {{ question.answer.text }}</div>
            }
          }
        </div>
      }
    </div>

    <button mat-raised-button class="button-cancel" color="danger" [routerLink]="['../../general']">
      {{ 'labels.buttons.Cancel' | translate }}
    </button>
    <button mat-raised-button class="button-submit" color="primary" (click)="submit()">
      {{ 'labels.buttons.Submit' | translate }}
    </button>
  </div>
</div>
